//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        search: {
            type: Object,
            default: () => ({
                rowguid: '',
				code: '',
				nodeguid: '',
				iskeyword: ''
            })
        }
    },
    data () {
        return {
            form: {
                userlist: [{
                    "settingguid": this.search['rowguid'],
                    "audittype":"指定人",
                    "auditid":"",
                    "auditname":null
                }],
				auditcata: '结果推送'
			},
            hsController: false
        }
    },
    computed: {
        detailExtra: function(){
            return {
                rowguid: this.search['nodeguid']
            }
        }
	},
	watch: {

	},
	methods: {
        auditSelect: function (e, node, obj){
            node.auditid = e[obj.id];
            node.auditname = e[obj.name];
        },
        addAuditor: function(){
            this.form.userlist.push({
                "settingguid": this.search['rowguid'],
                "audittype":"指定人",
                "auditid":"",
                "auditname":null
            })
        },
        submitHandler: function (){
            this.form.nodeguid = this.search['nodeguid'];

            this.$post(this.getStore('sysUrl') + '/node/settingadd', this.form, function(data, res){
                ShowMsg.call(this, res.msg);
                this.cancleHandler();
            },true)
        },
        cancleHandler() {
            this.$emit('close');
        },
        afterDetail: function(data) {
            if(!data.userlist) {
                data.userlist = this.form.userlist;
                data.auditcata = '结果推送'
            }
        }
	},
	mounted: function() {

	}
}
